<div
	#container
	class="scrollbar-wrapper"
	[class.mouse-is-over]="mouseIsOver"
	[class.auto-hide]="autoHide"
	[class.show-background]="!hideBackground"
	(mouseover)="onMouseOver($event)"
	(mouseout)="onMouseOut($event)"
	[class.orientation-horizontal]="orientation === 'horizontal'"
	[class.orientation-vertical]="orientation === 'vertical'"
	[class.resizable-bar]="useResize"
>
	<div
		#bar
		class="scrollbar-inner"
		[style.background-color]="barColor || null"
		bbDrag
		[bbDragContainer]="container"
		[bbDragAxis]="orientation === 'horizontal' ? 'x' : 'y'"
		(bbDragStarted)="onDragStart($event)"
		(bbDragMoved)="onDragging($event)"
		(bbDragEnded)="onDragEnd($event)"
	>
		<div class="resize-visual"></div>
	</div>
	<div class="resize-handle resize-handle-left" [hidden]="orientation === 'vertical'"
		#leftHandle
		bbDrag
		[bbDragContainer]="container"
		[bbDragAxis]="'x'"
		(bbDragStarted)="onResizeStart($event, 'left')"
		(bbDragMoved)="onResizing($event, 'left')"
		(bbDragEnded)="onResizeEnd($event, 'left')"
		(click)="onResizeHandleClick('left')"
	></div>
	<div class="resize-handle resize-handle-right" [hidden]="orientation === 'vertical'"
		#rightHandle
		bbDrag
		[bbDragContainer]="container"
		[bbDragAxis]="'x'"
		(bbDragStarted)="onResizeStart($event, 'right')"
		(bbDragMoved)="onResizing($event, 'right')"
		(bbDragEnded)="onResizeEnd($event, 'right')"
		(click)="onResizeHandleClick('right')"
	></div>
	<div class="resize-handle resize-handle-top" [hidden]="orientation === 'horizontal'"
		#topHandle
		bbDrag
		[bbDragContainer]="container"
		[bbDragAxis]="'y'"
		(bbDragStarted)="onResizeStart($event, 'top')"
		(bbDragMoved)="onResizing($event, 'top')"
		(bbDragEnded)="onResizeEnd($event, 'top')"
		(click)="onResizeHandleClick('top')"
	></div>
	<div class="resize-handle resize-handle-bottom" [hidden]="orientation === 'horizontal'"
		#bottomHandle
		bbDrag
		[bbDragContainer]="container"
		[bbDragAxis]="'y'"
		(bbDragStarted)="onResizeStart($event, 'bottom')"
		(bbDragMoved)="onResizing($event, 'bottom')"
		(bbDragEnded)="onResizeEnd($event, 'bottom')"
		(click)="onResizeHandleClick('bottom')"
	></div>
</div>
